import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { MemaLogo, inputCss } from '../components/ui';

const API_URL = process.env.REACT_APP_API_URL;

function formatarTelefone(valor) {
  return valor
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1)$2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 14);
}

const FIELDS = [
  { name: 'nome',     label: 'Nome completo',             type: 'text',     required: true },
  { name: 'email',    label: 'E-mail',                    type: 'email',    required: true },
  { name: 'telefone', label: 'Telefone (xx)xxxxx-xxxx',   type: 'tel',      required: true },
  { name: 'endereco', label: 'Endereço completo',         type: 'text',     required: true },
  { name: 'login',    label: 'Login',                     type: 'text',     required: true },
  { name: 'senha',    label: 'Senha',                     type: 'password', required: true },
];

export default function Cadastro() {
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', endereco: '', login: '', senha: '' });
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: name === 'telefone' ? formatarTelefone(value) : value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      await axios.post(`${API_URL}/cadastro`, { ...form, tipo: 'aluno' });
      setMsg('Cadastro realizado! Aguarde aprovação da professora.');
      setTimeout(() => navigate('/'), 2500);
    } catch (err) {
      setMsg(err.response?.data?.erro || 'Erro ao cadastrar');
    } finally {
      setLoading(false);
    }
  }

  const isSuccess = msg.includes('realizado');

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-canvas)', padding: '24px 16px',
    }}>
      <div style={{
        width: '100%', maxWidth: 360,
        background: 'var(--bg-surface)', borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border-hairline)',
      }}>
        {/* Header */}
        <div style={{
          padding: '28px 24px 20px', textAlign: 'center',
          borderBottom: '1px solid var(--border-hairline)',
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
            <MemaLogo size={44}/>
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: -0.5, color: 'var(--text-primary)' }}>
            Criar conta
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 3 }}>
            Alunos aguardam aprovação da professora
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {FIELDS.map(f => (
            <div key={f.name} style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>{f.label}</label>
              <input
                name={f.name}
                type={f.type}
                value={form[f.name]}
                onChange={handleChange}
                required={f.required}
                autoComplete={f.name === 'senha' ? 'new-password' : undefined}
                style={inputCss}
              />
            </div>
          ))}

          {msg && (
            <div style={{
              fontSize: 13, padding: '8px 12px', borderRadius: 'var(--radius-sm)',
              background: isSuccess ? 'color-mix(in oklch, var(--success) 10%, transparent)' : 'color-mix(in oklch, var(--danger) 10%, transparent)',
              color: isSuccess ? 'var(--success)' : 'var(--danger)',
            }}>{msg}</div>
          )}

          <button type="submit" disabled={loading} style={{
            height: 44, marginTop: 4, border: 'none', borderRadius: 'var(--radius-md)',
            background: 'var(--accent)', color: 'var(--accent-fg)',
            fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit', opacity: loading ? 0.7 : 1,
          }}>
            {loading ? 'Cadastrando…' : 'Cadastrar'}
          </button>
        </form>

        <div style={{ padding: '0 24px 20px', textAlign: 'center' }}>
          <button onClick={() => navigate('/')} style={{
            fontSize: 13, color: 'var(--accent)', background: 'none', border: 'none',
            cursor: 'pointer', fontFamily: 'inherit', fontWeight: 540,
          }}>
            Já tem conta? Fazer login
          </button>
        </div>
      </div>
    </div>
  );
}
